module.exports = __webpack_public_path__ + "static/media/2d-aerial-views.bdab0c66.jpg";